import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { reducer } from './reducer';
import { EmailStoreEffects } from './effects';
import { StoreModule } from '@ngrx/store';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature('email', reducer),
        EffectsModule.forFeature([EmailStoreEffects])
    ],
    providers: []
})
export class EmailStoreModule {}
